// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__7jPap","elementsContainer":"Hero_elementsContainer__QBNUH","heroSection":"Hero_heroSection__gqf-Z"};